import React from "react";
import { FaTimes } from "react-icons/fa";

const LocationDrawer = ({ isOpen, onClose }) => {
  return (
    <div className={`location-drawer ${isOpen ? "open" : ""}`}>
      <div className="drawer-header">
        <h2>Location</h2>
        <button className="drawer-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
      </div>
      <hr className="drawer-divider" />
      <div className="drawer-content">
        <div className="map-container" style={{ marginBottom: "10px" }}>
          <iframe
            title="Heritage Car Airports Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2930.5!2d-73.7414121!3d41.4763134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2b7b11a6cf2e5%3A0x8a9d408a32fdf9d2!2sHeritage%20Car%20Service!5e0!3m2!1sen!2sus!4v1672481726912!5m2!1sen!2sus"
            width="100%"
            height="200"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="location-details" style={{ fontSize: "14px", color: "#1f2937" }}>
          <h3 style={{ margin: "5px 0", color: "#0d2b3e" }}>Heritage Car Airports</h3>
          <p style={{ margin: "5px 0" }}>Rating: 5.0 (12 reviews)</p>
          <p style={{ margin: "5px 0" }}>Transportation Service</p>
          <hr style={{ margin: "10px 0" }} />
          <h4 style={{ margin: "5px 0", color: "#0d2b3e" }}>Overview</h4>
          <p style={{ margin: "5px 0" }}>Available 24/7 for all your transportation needs.</p>
          <hr style={{ margin: "10px 0" }} />
          <h4 style={{ margin: "5px 0", color: "#0d2b3e" }}>Contact Information</h4>
          <p style={{ margin: "5px 0" }}>Phone: (914) 276-2961 | (845) 225-8161</p>
          <p style={{ margin: "5px 0" }}>Email: heritagecarairport@gmail.com</p>
          <p style={{ margin: "5px 0" }}>Open 24 hours</p>
        </div>
      </div>
      <style>{`
        .location-drawer {
          position: fixed;
          top: 0;
          left: 0;
          width: 180px;
          height: 100%;
          background: rgba(255, 255, 255, 0.95);
          border-right: 1px solid #2B3F50;
          box-shadow: 2px 0 8px rgba(0,0,0,0.3);
          transform: translateX(-100%);
          transition: transform 0.3s ease;
          z-index: 101;
          display: flex;
          flex-direction: column;
          backdrop-filter: brightness(1.05);
        }
        .location-drawer.open {
          transform: translateX(0);
        }
        .drawer-header {
          background: rgba(248,248,248,0.95);
          border-bottom: 1px solid #ddd;
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .drawer-divider {
          border: 0;
          height: 1px;
          background: #2B3F50;
          margin: 0;
        }
        .drawer-content {
          padding: 16px;
          overflow-y: auto;
          flex: 1;
        }
      `}</style>
    </div>
  );
};

export default LocationDrawer;
